import { axios as request } from "../../request/http";

const interfaceUrl = {
  "api_shopWalletList": "/shop/wallet/queryList", // 查询账户余额
}

// initial state
const state = {
    shopWalletList: {},
}

// getters
const getters = {
    getShopWalletList: state => {
    return state.shopWalletList
  },
}

// actions
const actions = {
    getShopWalletList: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopWalletList,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SHOP_WALLET_LIST', res || {});
      } else {
        commit('SHOP_WALLET_LIST', {});
      }
    }).catch(err => {
      commit('SHOP_WALLET_LIST', {});
    })
  },
}

// mutations
const mutations = {
  SHOP_WALLET_LIST: (state, pageData) => {
    state.shopWalletList = pageData;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/wallet.js